import React, {ChangeEvent, FocusEvent, useEffect, useReducer, useState} from 'react';
import {withFormik} from 'formik';
import {toast} from "react-toastify";
import {Row} from 'antd';
import Select from 'antd/lib/select';
import schema from './schema';
import {Button, Col, Form, Label, ValueCard,} from './styles';
import {PainelVendasFilterProps,} from '../../../../../global/dataTransferObjects/transacoesTempoReal';
import {CommercialOption, FormProps, IFormProps} from '../../types';
import {formatDate} from '../../../../../utils/formatDate';
import useGetMe from '../../../../../hooks/useCurrentUser'
import {InitialState, Reducer} from "../../actions/reducer";
import VendaServices from "../../services/VendaServices";
import {validateValueFilter} from "../../../shared/valueFilter";
import ValueFilterFields from "../../../shared/ValueFilterFields";

const FormFilter: React.FC<FormProps> = (props: FormProps) => {
  const [state, dispatch] = useReducer(Reducer, InitialState);
  const user = useGetMe();
  const vendasServices = new VendaServices();
  const {handleSubmit, totals} = props;
  const [bandeira, setBandeira] = useState<string>('');
  const [tipoPagamento, setTipoPagamento] = useState<string>('');
  const [businessName, setBusinessName] = useState<string>('');
  const [acquirerNsu, setAcquirerNsu] = useState<string>('');
  const [acquirer, setAcquirer] = useState<number>(-1);
  const [capture, setCapture] = useState<string>('');
  const [status, setStatus] = useState<number | null>(1);
  const [initialDate, setInitialDate] = useState<string | Date>('');
  const [finalDate, setFinalDate] = useState<string | Date>('');
  const [initialDateFilterType, setInitialDateFilterType] = useState<string>('text');
  const [finalDateFilterType, setFinalDateFilterType] = useState<string>('text');
  const [totalParamsState, setTotalParamsState] = useState();
  const [merchantId, setMerchantId] = useState<string>('')
  const [orderNumber, setOrderNumber] = useState<string>('');
  const [cancellationStatus, setCancellationStatus] = useState<number | null>(null);
  const [serialNumber, setSerialNumber] = useState<string>('');
  const [commercialHierId, setCommercialHierId] = useState<any>(null);
  const [commercialOptions, setCommercialOptions] = useState<CommercialOption[]>([]);
  const [filteredCommercialOptions, setFilteredCommercialOptions] = useState<CommercialOption[]>([]);
  const [parcelMin, setParcelMin] = useState<string>('');
  const [parcelMax, setParcelMax] = useState<string>('');

  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');

    const startOfDay = `${yyyy}-${mm}-${dd}T00:00:00`;
    const endOfDay = `${yyyy}-${mm}-${dd}T23:59:59`;

    props.setFieldValue('initialDate', startOfDay);
    props.setFieldValue('finalDate', endOfDay);
    setInitialDate(startOfDay);
    setFinalDate(endOfDay);
  }, []);

  const formatMoney = (value: number) => {
    const formattedValue = (value).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formattedValue;
  };

  const getValorVendaTotal = (): string => {
    let valor: number = 0;
    if (totals) valor = totals.totalGross;

    if (isNaN(valor)) valor = 0;
    const valorFormatado: string = formatMoney(valor as number);
    return valorFormatado;
  };

  const getTicket = (): string => {
    if (totals?.totalGross !== undefined && totals?.count !== undefined) {
      let avarageTicket = totals?.totalGross / totals?.count;
      if (isNaN(avarageTicket)) avarageTicket = 0;
      const valorFormatado: string = formatMoney(avarageTicket as number);
      return valorFormatado;
    }
    else {
      const valorFormatado: string = formatMoney(0);
      return valorFormatado;
    }
  };

  const getValorLiquidoTotal = (): string => {
    let valor: number = 0;
    if (totals) valor = totals.totalLiquid;

    if (isNaN(valor)) valor = 0;
    const valorFormatado: string = formatMoney(valor as number);
    return valorFormatado;
  };

  const getTotalTransacoes = (): number => {
    let valor: number = 0;
    if (totals) valor = totals.count;

    if (isNaN(valor)) valor = 0;
    return valor;
  };

  const handleChangeBandeira = (value: string): void => {
    setBandeira(value);
    props.setFieldValue('bandeira', value);
  };
  const handleChangeTipoPagamento = (value: string): void => {
    setTipoPagamento(value);
    props.setFieldValue('tipoPagamento', value);
  };

  const handleChangeStatus = (value: number | null): void => {
    setStatus(value);
    props.setFieldValue('status', value);
  };

  const handleBusinessNameChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setBusinessName(event.target.value);
    props.setFieldValue('businessName', event.target.value);
  };

  const handleAcquirerNsuChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setAcquirerNsu(event.target.value);
    props.setFieldValue('acquirerNsu', event.target.value);
  };

  const handleMerchantId = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setMerchantId(event.target.value);
    props.setFieldValue('merchantId', event.target.value);
  };

  const handleChangeAcquirer = (value: number): void => {
    setAcquirer(Number(value));
    props.setFieldValue('acquirer', Number(value));
  };

  const handleChangeCapture = (value: string): void => {
    setCapture(value);
    props.setFieldValue('capture', value);
  };

  const handleChangeInitialDate = (event: ChangeEvent<HTMLInputElement>): void => {
    setInitialDate(event.target.value);
    props.setFieldValue('initialDate', event.target.value);
  };

  const handleChangeFinalDate = (event: ChangeEvent<HTMLInputElement>): void => {
    setFinalDate(event.target.value);
    props.setFieldValue('finalDate', event.target.value);
  };

  const handleOrderNumber = (event: ChangeEvent<HTMLInputElement>): void => {
    setOrderNumber(event.target.value);
    props.setFieldValue('orderNumber', event.target.value);
  };

  const handleFocusInitialDateFilter = (event: FocusEvent<HTMLInputElement>): void => {
    setInitialDateFilterType('datetime-local');
    if (!event.target.value) {
      const now: Date = new Date();
      const year: number = now.getFullYear();
      const month: string = String(now.getMonth() + 1).padStart(2, '0');
      const day: string = String(now.getDate()).padStart(2, '0');
      const midnight: string = `${year}-${month}-${day}T00:00:00`;

      event.target.value = midnight;
      setInitialDate(event.target.value);
      props.setFieldValue('initialDate', event.target.value);
    }
  };

  const handleFocusFinalDateFilter = (event: FocusEvent<HTMLInputElement>): void => {
    setFinalDateFilterType('datetime-local');
    if (!event.target.value) {
      const now: Date = new Date();
      const year: number = now.getFullYear();
      const month: string = String(now.getMonth() + 1).padStart(2, '0');
      const day: string = String(now.getDate()).padStart(2, '0');
      const almostMidnight: string = `${year}-${month}-${day}T23:59:59`;

      event.target.value = almostMidnight;
      setFinalDate(event.target.value);
      props.setFieldValue('finalDate', event.target.value);
    }
  };

  const handleChangeCancellationStatus = (value: number | null): void => {
    setCancellationStatus(value);
    props.setFieldValue('cancellationStatus', value);
  };

  const handleSerialNumber = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSerialNumber(event.target.value);
    props.setFieldValue('serialNumber', event.target.value);
  };

  const handleCommercialHierId = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    // filtrar a lista de oções

    if (value.trim() === '') {
      setFilteredCommercialOptions([]);
    } else {
      setFilteredCommercialOptions(
        commercialOptions.filter(option =>
          option.commercialLevelName.toLowerCase().includes(value.toLowerCase())
        )
      );
    }

    setCommercialHierId(event.target.value);
    props.setFieldValue('commercialHierId', event.target.value);
  };

  const handleSelect = (option: CommercialOption) => {
    setCommercialHierId(option.commercialLevelName);
    props.setFieldValue('commercialHierId', option.id);

    setFilteredCommercialOptions([]);
  };

  const handleCommercialOptions = async (): Promise<CommercialOption[]> => {
    return await vendasServices.getCommercialOptions();
  };

  const handleParcelMin = (event: ChangeEvent<HTMLInputElement>): void => {
    setParcelMin(event.target.value);
    props.setFieldValue('parcelMin', event.target.value ? Number(event.target.value) : null);
  };

  const handleParcelMax = (event: ChangeEvent<HTMLInputElement>): void => {
    setParcelMax(event.target.value);
    props.setFieldValue('parcelMax', event.target.value ? Number(event.target.value) : null);
  };

  useEffect(() => {
    handleCommercialOptions().then(response => {
      setCommercialOptions(response);
    });
  }, []);

  return (
    <>
      <ValueCard>
        <div>
          <p style={{fontWeight: 'bolder'}}>Valor das vendas: </p>
          <p>{getValorVendaTotal()}</p>
        </div>

        <div>
          <p style={{fontWeight: 'bolder'}}>Valor Líquido: </p>
          <p>{getValorLiquidoTotal()}</p>
        </div>

        <div>
          <p style={{fontWeight: 'bolder'}}>Nº de Transações: </p>
          <p>{getTotalTransacoes()}</p>
        </div>

        <div>
          <p style={{fontWeight: 'bolder'}}>Ticket Médio: </p>
          <p>{getTicket()}</p>
        </div>
      </ValueCard>

      <Form onSubmit={handleSubmit}>
        <Row>
          <Label>Filtrar por:</Label>
        </Row>
        <Row
          gutter={16}
        >
            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <input type={initialDateFilterType} onFocus={handleFocusInitialDateFilter} name="initialDate"
                     onChange={handleChangeInitialDate} placeholder="Data inicial" step="1"/>
            </Col>

            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <input type={finalDateFilterType} onFocus={handleFocusFinalDateFilter} name="finalDate"
                     onChange={handleChangeFinalDate} placeholder="Data final" step="1"/>
            </Col>

            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <Select
                defaultValue=""
                style={{width: '100%'}}
                onChange={handleChangeBandeira}
                options={[
                  {
                    value: '',
                    label: 'Bandeira',
                  },
                  {
                    value: '3',
                    label: 'AMEX',
                  },
                  {
                    value: '171',
                    label: 'ELO',
                  },
                  {
                    value: '9',
                    label: 'HIPERCARD',
                  },
                  {
                    value: '2',
                    label: 'MASTERCARD',
                  },
                  {
                    value: '1',
                    label: 'VISA',
                  },
                  {
                    value: '999',
                    label: 'PIX',
                  },
                ]}
              />
            </Col>

            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <Select
                defaultValue=""
                style={{width: '100%'}}
                onChange={handleChangeTipoPagamento}
                options={[
                  {
                    value: '',
                    label: 'Tipo pagamento',
                  },
                  {
                    value: 'Crédito à Vista',
                    label: 'Crédito à Vista',
                  },
                  {
                    value: 'Parcelamento sem Juros',
                    label: 'Parcelamento sem Juros',
                  },
                  {
                    value: 'Parcelamento com Juros',
                    label: 'Parcelamento com Juros',
                  },
                  {
                    value: 'Cancelamento',
                    label: 'Cancelamento',
                  },
                  {
                    value: 'Débito',
                    label: 'Débito',
                  },
                  {
                    value: 'Pré-Autorização',
                    label: 'Pré-Autorização',
                  },
                  {
                    value: 'PIX',
                    label: 'Pix',
                  },
                ]}
              />
            </Col>

            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <input type="number" min="1" placeholder="Parcela inicial" value={parcelMin} onChange={handleParcelMin}/>
            </Col>

            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <input type="number" min="1" placeholder="Parcela final" value={parcelMax} onChange={handleParcelMax}/>
            </Col>

            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <input placeholder="NSU" onChange={handleAcquirerNsuChange}/>
            </Col>

            {(user.userType === 3 || user.userType === 6 || user.userType === 7) && (
              <>
                <Col xs={{ flex: '100%' }}
                     sm={{ flex: '50%' }}
                     md={{ flex: '40%' }}
                     lg={{ flex: '20%' }}
                     xl={{ flex: '10%' }}>
                  <input placeholder="Empresa" onChange={handleBusinessNameChange}/>
                </Col>

                <Col xs={{ flex: '100%' }}
                     sm={{ flex: '50%' }}
                     md={{ flex: '40%' }}
                     lg={{ flex: '20%' }}
                     xl={{ flex: '10%' }}>
                  <input placeholder="Cod. Lojista" onChange={handleMerchantId}/>
                </Col>
              </>
            )}

            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <Select
                defaultValue={1}
                style={{width: '100%'}}
                onChange={handleChangeStatus}
                options={[
                  {
                    value: null,
                    label: 'Status',
                  },
                  {
                    value: 0,
                    label: 'Pendente',
                  },
                  {
                    value: 1,
                    label: 'Confirmada',
                  },
                  {
                    value: 2,
                    label: 'Desfeita',
                  },
                  {
                    value: 3,
                    label: 'Negada',
                  },
                  {
                    value: 4,
                    label: 'Cancelada',
                  },
                ]}
              />
            </Col>

          {(user.userType === 3 || user.userType === 6) && (
            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <Select
                defaultValue={-1}
                style={{width: '100%'}}
                onChange={handleChangeAcquirer}
                options={[
                  {
                    value: -1,
                    label: 'Adquirente',
                  },
                  {
                    value: 3,
                    label: 'Adiq',

                  },
                  {
                    value: 10,
                    label: 'Rede',
                  },
                  {
                    value: 99,
                    label: 'Valori',
                  },
                ]}
              />
            </Col>
          )}

          {(user.userType === 3 || user.userType === 6) && (
            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <Select
                defaultValue=""
                style={{width: '100%'}}
                onChange={handleChangeCapture}
                options={[
                  {
                    value: '',
                    label: 'Captura',
                  },
                  {
                    value: 'phoebus',
                    label: 'Phoebus',
                  },
                  {
                    value: 'aditum',
                    label: 'Aditum',
                  },
                ]}
              />
            </Col>
          )}

            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <input placeholder="Id Pedido" onChange={handleOrderNumber}/>
            </Col>

          <Col xs={{ flex: '100%' }}
               sm={{ flex: '50%' }}
               md={{ flex: '40%' }}
               lg={{ flex: '20%' }}
               xl={{ flex: '10%' }}>
            <Select
              defaultValue={null}
              style={{width: '100%'}}
              onChange={handleChangeCancellationStatus}
              options={[
                {
                  value: null,
                  label: 'Status Cancelamento',
                },
                {
                  value: -1,
                  label: 'Totalmente Cancelada',
                },
                {
                  value: -2,
                  label: 'Parcialmente Cancelada',
                },
              ]}
            />
          </Col>

          <Col xs={{ flex: '100%' }}
               sm={{ flex: '50%' }}
               md={{ flex: '40%' }}
               lg={{ flex: '20%' }}
               xl={{ flex: '10%' }}>
            <input placeholder="Número de série" onChange={handleSerialNumber}/>
          </Col>

          {(user.userType === 3 || user.userType === 6 || user.userType === 7) && (
            <Col xs={{ flex: '100%' }}
                 sm={{ flex: '50%' }}
                 md={{ flex: '40%' }}
                 lg={{ flex: '20%' }}
                 xl={{ flex: '10%' }}>
              <input type="text"
                     value={commercialHierId}
                     onChange={handleCommercialHierId}
                     placeholder="Filtro comercial"/>
              {filteredCommercialOptions.length > 0 && (
                <ul
                  style={{
                    listStyle: 'none',
                    margin: 0,
                    padding: 0,
                    position: 'absolute',
                    width: '100%',
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    zIndex: 10
                  }}
                >
                  {filteredCommercialOptions.map(option => (
                    <li
                      key={option.id}
                      onClick={() => handleSelect(option)}
                      style={{
                        padding: '8px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #eee'
                      }}
                    >
                      {option.commercialLevelName}
                    </li>
                  ))}
                </ul>
              )}
            </Col>
          )}

          <ValueFilterFields col={Col} setFieldValue={props.setFieldValue}/>

          <Col xs={{flex: '100%'}}
               sm={{flex: '50%'}}
               md={{flex: '40%'}}
               lg={{flex: '20%'}}
               xl={{flex: '10%'}}>
            <Button htmlType="submit">
              Consultar
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  )
}
export default withFormik<IFormProps, PainelVendasFilterProps>({
  mapPropsToValues: (): PainelVendasFilterProps => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');

    const startOfDay = `${yyyy}-${mm}-${dd}T00:00:00`;
    const endOfDay = `${yyyy}-${mm}-${dd}T23:59:59.999`;

    return {
      initialDate: startOfDay,
      finalDate: endOfDay,
      bandeira: '',
      tipoPagamento: '',
      businessName: '',
      acquirerNsu: '',
      merchantId: '',
      orderNumber: '',
      acquirer: -1,
      capture: '',
      status: 1,
      cancellationStatus: null,
      serialNumber: '',
      commercialHierId: '',
      parcelMin: null,
      parcelMax: null,
      valueField: null,
      valueOperator: null,
      valueMin: null,
      valueMax: null,
    };
  },
  validationSchema: schema,
  handleSubmit: (values, { props }) => {
    if (values.parcelMin != null && values.parcelMax != null && values.parcelMax < values.parcelMin) {
      toast.error('A parcela final não pode ser menor que a parcela inicial!');
      return;
    }

    if (!validateValueFilter(values)) return;

    // Datas ausentes/inválidas seguem como null ao Flux, que assume o dia de hoje como período.
    const test = {
      ...values,
      initialDate: formatDate(values.initialDate),
      finalDate: formatDate(values.finalDate),
    };

    props.onFormSubmit(test);
  },
})(FormFilter);
